import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Injectable} from '@angular/core';
import {ProductDataService} from '../services/product-data.service';

/**
 * Guard that intercepts friendly URL slugs and redirects to the canonical
 * /products/:productCode (or /samples/:productCode) route.
 *
 * e.g.  /Bonjour  ->  /products/fas44
 *       /Berlin   ->  /products/dar42
 *
 * Mappings are maintained in ProductDataService.friendlyUrlMap alongside all
 * other product data.
 */
@Injectable({providedIn: 'root'})
export class FriendlyUrlGuard implements CanActivate {
  constructor(
    private readonly productDataService: ProductDataService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    const slug = route.paramMap.get('friendlyUrl') ?? '';
    const mapping = this.productDataService.resolveFriendlyUrl(slug);

    if (mapping) {
      const segments: string[] = [mapping.routeContext, mapping.productCode];
      if (mapping.subRoute) {
        segments.push(mapping.subRoute);
      }
      return this.router.createUrlTree(segments);
    }

    // No mapping found - redirect to home
    return this.router.createUrlTree(['/']);
  }
}
